export default "<div class=\"not-found\"></div>\r\n"